import { css } from '@/styled-system/css';

export const comboboxHeadingStyles = css.raw({
  'textStyle': 'body-sm-bold',
  'color': 'Combobox.Heading.label',
  'textTransform': 'uppercase',
  'paddingBlock': 'Combobox.Heading.padding.vert',
  'paddingInline': 'Combobox.Heading.padding.horz',
  'backgroundColor': 'Combobox.Heading.bg',
  'display': 'flex',
  'alignItems': 'center',
  'gap': 'Combobox.Heading.gap.leading',

  '& > [data-c11n-component="Icon"]': {
    color: 'Combobox.Heading.icon',
    width: 'Combobox.Heading.icon.width',
    height: 'Combobox.Heading.icon.height',
  },
});
